/** portal/uploadLimit.ts — 고객 자료수집 포털 올리기 한도 (backend/routes/portal.js PORTAL_FILE_MB · nginx /api/portal/:id/upload 와 같게 · 2026-11-02)
 *  · 보내기 전에 미리 알려 준다 — 다 올린 뒤에 실패하면 고객이 몇 분을 기다린 끝에 영문 모를 오류를 본다 */
export const PORTAL_FILE_MB = 300;
export const PORTAL_TOTAL_MB = 1000;
export const PORTAL_MAX_FILES = 10;

const MB = 1024 * 1024;

/** 한도를 넘으면 고객에게 보일 말 · 괜찮으면 '' */
export function portalSizeError(files: ArrayLike<{ name: string; size: number }>): string {
  const list = Array.from(files);
  if (list.length > PORTAL_MAX_FILES) return `한 번에 ${PORTAL_MAX_FILES}개 파일까지 올릴 수 있어요. 나눠서 올려 주세요.`;
  const big = list.find((f) => f.size > PORTAL_FILE_MB * MB);
  if (big) return `「${big.name.length > 24 ? big.name.slice(0, 24) + '…' : big.name}」이(가) ${Math.round(big.size / MB)}MB예요. 파일 하나는 ${PORTAL_FILE_MB}MB까지 올릴 수 있어요.`;
  const sum = list.reduce((s, f) => s + f.size, 0);
  if (sum > PORTAL_TOTAL_MB * MB) return `한 번에 ${PORTAL_TOTAL_MB / 1000}GB까지 올릴 수 있어요(지금 ${(sum / 1000 / MB).toFixed(1)}GB). 나눠서 올려 주세요.`;
  return '';
}

/** 응답이 JSON 이 아닐 때(nginx 413 · 502 등 HTML) 알아듣는 말로 */
export function portalHttpError(status: number): string {
  if (status === 413) return `파일이 너무 커요. 파일 하나는 ${PORTAL_FILE_MB}MB, 한 번에 ${PORTAL_TOTAL_MB / 1000}GB까지 올릴 수 있어요.`;
  if (status === 502 || status === 504) return '올리는 데 시간이 오래 걸려 끊겼어요. 파일을 나눠서 다시 올려 주세요.';
  return '업로드 실패 (' + status + ')';
}
